const loggedUserConfig = require('../src/commons/resources/loggedUser');

const config = loggedUserConfig.default.getBrandConfig();

const getLoginUrl = () => {
  return config?.id === 'payretailers' ? process.env.VUE_APP_LOGIN_PAYRETAILERS_URL : process.env.VUE_APP_LOGIN_URL;
};

/**
 * @typedef {Object} Config
 * @property {Object} url
 * @property {string} url.login
 * @property {string} url.cdn
 * @property {string} url.contacerta
 * @property {Object} url.api
 * @property {string} url.api.transfeera
 * @property {string} url.api.login
 * @property {string} url.api.checkpoint
 * @property {string} url.api.payin
 * @property {string} url.api.billing
 * @property {Object} app
 * @property {Object} app.sentry
 * @property {string} [app.sentry.dsn]
 * @property {string} [app.config]
 */

/**
 * @type {Config}
 */
module.exports = {
  url: {
    login: getLoginUrl(),
    cdn: process.env.VUE_APP_CDN_URL,
    contacerta: process.env.VUE_APP_CONTACERTA_API_URL,
    api: {
      transfeera: process.env.VUE_APP_TRANSFEERA_API_URL,
      login: process.env.VUE_APP_LOGIN_API_URL,
      checkpoint: process.env.VUE_APP_CHECKPOINT_API_URL,
      payin: process.env.VUE_APP_PAYIN_API_URL,
      billing: process.env.VUE_APP_BILLING_API_URL
    }
  },
  app: {
    sentry: {
      dsn: process.env.VUE_APP_SENTRY_DSN
    }
  },
  branding: config
};
